import firebase from "firebase/app";

/** ドキュメントIDの設定 */
export const SET_DOCUMENT_ID = "SET_DOCUMENT_ID";

/** ドキュメントデータの設定 */
export const SET_DOCUMENT_DATA = "SET_DOCUMENT_DATA";

/** ドキュメントの保存 */
export const SAVE_DOCUMENT = "SAVE_DOCUMENT";

/** ドキュメントの更新 */
export const UPDATE_DOCUMENT = "UPDATE_DOCUMENT";

/** ドキュメントの削除 */
export const DELETE_DOCUMENT = "DELETE_DOCUMENT";

/** ドキュメントの取得 */
export const GET_DOCUMENT = "GET_DOCUMENT";

export interface FirestoreState {
  /** コレクションID（固定） */
  collection: string;
  /** ドキュメントID（ログイン職員ID） */
  documentId: string;
  /** Firebaseデータ */
  firebaseData?: firebase.firestore.DocumentReference<
    firebase.firestore.DocumentData
  >;
  /** Firebaseから取得したデータ */
  data?: firebase.firestore.DocumentData;
  /** エラー時 */
  error: boolean;
}
